import { runInInjectionContext, Injector, inject } from '@angular/core';
import { Router } from '@angular/router';
import Shepherd from 'shepherd.js';
type StepOptions = Shepherd.Step.StepOptions;
import { commonConfig, waitForElement } from './utils';

export function getSearchTourSteps(injector: Injector): StepOptions[] {
  return runInInjectionContext(injector, () => {
    const router = inject(Router);
    return [
      {
        id: 'Search-step-01',
        title: 'Access the Search Tool',
        text: 'Use this feature to search all documents included in your subscription using relevant keywords.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#HomeStep3',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              router.navigate(['/site/search-results']).then(() => {
                this.next();
              });
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Search-step-02',
        title: 'Explore Search Results',
        text: 'This section displays all documents that match your search criteria.',
        classes: 'shepherd-custom shepherd-custom-upper-position',
        attachTo: {
          element: '#SearchStep2',
          on: 'top' as const
        },
        beforeShowPromise: function() {
          return new Promise<void>((resolve) => {
            waitForElement('#SearchStep2').then(() => {
              setTimeout(() => {
                resolve();
              }, 500);
            });
          });
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ],
        ...commonConfig
      },
      {
        id: 'Search-step-03',
        title: 'Refine Your Search',
        text: 'Use the filters to narrow down your results by service, region, document type, or time period.',
        classes: 'shepherd-custom shepherd-custom-left-position',
        attachTo: {
          element: '#SearchStep3',
          on: 'left' as const
        },
        buttons: [
          {
            text: 'Next',
            action() {
              this.next();
            }
          }
        ]
      },
      {
        id: 'Search-step-04',
        title: 'Clear All Filters',
        text: 'Click this button to quickly reset all active filters and start a new search.',
        classes: 'shepherd-custom shepherd-custom-lower-position',
        attachTo: {
          element: '#SearchStep4',
          on: 'bottom' as const
        },
        buttons: [
          {
            text: 'Finish',
            action() {
              this.complete();
              router.navigate(['/site/help']);
            }
          }
        ]
      }
    ];
  });
}